module.exports = __webpack_public_path__ + "static/media/intro_icon_2.8cece9c0.svg";